export default __webpack_public_path__ + "static/1368-e2202653cf180f82aab2d92a323a090e.gif";